/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import React, { Component } from 'react';

class Error extends Component {

    handleClick(e) {
        e.preventDefault();
        window.location.reload();
    }

    render () {

        return (

            <div className='loader-error'>

                <span className='material-icons'>
                    error
                </span>

                Sorry, an error has occurred.

                <br/><br/>

                <a href='# ' onClick={(e) => { this.handleClick(e) }}>
                    Retry?
                </a>

            </div>

        )

    }

}

export default Error;
